import { isBoolean, isObject } from 'util';

import * as HotelviewActions from '../actions/hotelview';
import * as QueryActions from '../actions/query';
import * as TabsActions from '../../../xena-tabs/state-management/actions/tabs';

import { MergedHotelviewResponseModel } from '../../../../shared/models/hotelview/merged-response.model';
import { HotelviewDataIdAttributes } from '../../../../shared/models/hotelview/data-id-attributes.model';
import { KeyValueObject } from '../../../../shared/models/key-value-object';
import { InitialState as InitialTabState } from '../../../xena-tabs/state-management/reducers/tabs';
import { parseHotelviewDataIdAttributesKey } from '../../../../shared/help/functions';



export class State {
	tabs: Array<{
		tabId: number;
		selected: boolean;
		activeHotelview: HotelviewDataIdAttributes;
		hotelviewPanelExpanded: boolean;
		hotelviewDialogVisible: boolean;
		toggleHotelviewPanelDone: boolean;
	}>;
	hotelviewData: KeyValueObject<MergedHotelviewResponseModel>;
}

export const InitialState: State = {
	tabs: [{
		tabId: InitialTabState[0].id,
		selected: InitialTabState[0].selected,
		activeHotelview: null,
		hotelviewPanelExpanded: false,
		hotelviewDialogVisible: false,
		toggleHotelviewPanelDone: true
	}],
	hotelviewData: {}
};


export function reducer(state: State = InitialState, action: HotelviewActions.All | QueryActions.All | TabsActions.All): State {
	switch (action.type) {
		case HotelviewActions.SET_ACTIVE_HOTELVIEW:
			return {
				...state,
				tabs: state.tabs.map(s => s.selected ? { ...s, activeHotelview: action.payload } : s)
			};

		case HotelviewActions.LOAD_HOTELVIEW_DATA_SUCCESS:
			return {
				...state,
				hotelviewData: {
					...state.hotelviewData,
					[parseHotelviewDataIdAttributesKey(action.params)]: action.payload
				}
			};

		case HotelviewActions.EXPAND_HOTELVIEW_PANEL:
			return {
				...state,
				tabs: state.tabs.map(s => s.selected
					? ({
						...s,
						hotelviewPanelExpanded: true,
						toggleHotelviewPanelDone: false
					})
					: s
				),
			};

		case HotelviewActions.COLLAPSE_HOTELVIEW_PANEL:
			return {
				...state,
				tabs: state.tabs.map(s => s.selected
					? ({
						...s,
						hotelviewPanelExpanded: false,
						toggleHotelviewPanelDone: false
					})
					: s
				)
			};

		case HotelviewActions.TOGGLE_HOTELVIEW_PANEL_DONE:
			return {
				...state,
				tabs: state.tabs.map(s => s.selected ? ({ ...s, toggleHotelviewPanelDone: true }) : s)
			};

		case HotelviewActions.OPEN_HOTELVIEW_DIALOG:
			return {
				...state,
				tabs: state.tabs.map(s => s.selected ? ({ ...s, hotelviewDialogVisible: true }) : s)
			};

		case HotelviewActions.CLOSE_HOTELVIEW_DIALOG:
			return {
				...state,
				tabs: state.tabs.map(s => s.selected ? ({ ...s, hotelviewDialogVisible: false }) : s)
			};

		case QueryActions.RESET_QUERY:
			return {
				...state,
				tabs: state.tabs.map(s => s.selected ? { ...s, activeHotelview: null, hotelviewPanelExpanded: false, hotelviewDialogVisible: false } : s)
			};

		case HotelviewActions.INIT_HOTELVIEW_TABS:
			return {
				...state,
				tabs: action.payload.map((tab, index) => ({
					tabId: tab.id,
					selected: tab.selected,
					activeHotelview: state.tabs[index] && isObject(state.tabs[index].activeHotelview) ? state.tabs[index].activeHotelview : InitialState.tabs[0].activeHotelview,
					hotelviewPanelExpanded: state.tabs[index] && isBoolean(state.tabs[index].hotelviewPanelExpanded) ? state.tabs[index].hotelviewPanelExpanded : InitialState.tabs[0].hotelviewPanelExpanded,
					hotelviewDialogVisible: state.tabs[index] && isBoolean(state.tabs[index].hotelviewDialogVisible) ? state.tabs[index].hotelviewDialogVisible : InitialState.tabs[0].hotelviewDialogVisible,
					toggleHotelviewPanelDone: state.tabs[index] && isBoolean(state.tabs[index].toggleHotelviewPanelDone) ? state.tabs[index].toggleHotelviewPanelDone : InitialState.tabs[0].toggleHotelviewPanelDone
				}))
			};

		case TabsActions.ADD_TAB:
			return {
				...state,
				tabs: state.tabs.concat({
					tabId: action.payload.id,
					selected: false,
					activeHotelview: null,
					hotelviewPanelExpanded: false,
					hotelviewDialogVisible: false,
					toggleHotelviewPanelDone: true
				})
			};

		case TabsActions.SELECT_TAB:
			return {
				...state,
				tabs: state.tabs.map(s => ({ ...s, selected: s.tabId === action.payload.id }))
			};

		case TabsActions.REMOVE_TAB:
			if (state.tabs.length === 1) {
				return state;
			}

			const tabToRemove = state.tabs.find(s => s.tabId === action.payload.id);
			const newState = state.tabs.filter(s => s.tabId !== action.payload.id);

			if (tabToRemove.selected) {
				newState[0].selected = true;
			}

			return { ...state, tabs: newState };

		default:
			return state;
	}
}

export const GetActiveHotelview = (s: State): HotelviewDataIdAttributes => s.tabs.find(t => t.selected).activeHotelview;
export const GetHotelviewData = (s: State): KeyValueObject<MergedHotelviewResponseModel> => s.hotelviewData;

export const HotelviewDialogVisible = (s: State): boolean => s.tabs.find(t => t.selected).hotelviewDialogVisible;
export const HotelviewPanelExpanded = (s: State): boolean => s.tabs.find(t => t.selected).hotelviewPanelExpanded;
export const ToggleHotelviewPanelDone = (s: State): boolean => s.tabs.find(t => t.selected).toggleHotelviewPanelDone;



// WEBPACK FOOTER //
// ./src/app/xena/core/state-management/reducers/hotelview.ts